export default __webpack_public_path__ + "static/media/storageUnit1-afterA.cad18a92.jpg";